import { Typography, Card, Button, Tabs } from "antd";

const { Paragraph, Text } = Typography;
function Portfolio(props) {

  return (
    <div>
     Portfolio
    </div>
  );
}

export default Portfolio;
